import React, {useState} from "react"
import { Link } from "gatsby"
import WSFlywheel from "../svgs/components/ws-flywheel"
import TermsAndConditions from "./cart/terms-and-conditions"
import PrivacyPolicy from "./cart/privacy-policy"
import Modal from 'react-bootstrap/Modal'

import LinkedinLogo from "../svgs/linkedin-logo-footer.svg"
import FacebookLogo from "../svgs/facebook-logo-footer.svg"
import YoutubeLogo from "../svgs/youtube-logo-2.svg"

const Footer = () => {

    const [showToc, setShowToc] = useState(false);
    const [showPP, setShowPP] = useState(false);

    const handleCloseToc = () => setShowToc(false);
    const handleShowToc = () => setShowToc(true);
    const handleClosePP = () => setShowPP(false);
    const handleShowPP = () => setShowPP(true);

    return(
        <footer className='container top-border pt-6 d-print-none' style={{paddingBottom:'6.25rem', display:'block'}}>
            <div className='mb-5 row justify-content-center'>
                <div className='col-md-3 col-sm-6 px-3 pb-3 d-flex justify-content-left flex-column'>
                    <WSFlywheel alt="WhyteSpyder from Flywheel" className="mb-3 w-100"/>
                </div>
            </div>
            
            
            <div className='text-muted font-xs d-flex'>
                <span className='mx-auto'>
                    © {new Date().getFullYear()} {` `} WhyteSpyder, LLC, All Rights Reserved.
                    {` `} 
                    <a className='text-reset' href='#toc-modal' data-bs-toggle="modal" onClick={handleShowToc}>{`Terms of Service`}</a>
                    {` `} 
                    &
                    {` `} 
                    <a className='text-reset' href='#pp-modal' data-bs-toggle="modal" onClick={handleShowPP}>{`Privacy Policy`}</a>
                </span>
            </div>
            <Modal show={showToc} size="lg" onHide={handleCloseToc}>
                <Modal.Header closeButton>
                    <Modal.Title>Terms & Conditions</Modal.Title>
                </Modal.Header>
                <Modal.Body><TermsAndConditions /></Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseToc}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal show={showPP} size="lg" onHide={handleClosePP}>
                <Modal.Header closeButton>
                    <Modal.Title>Privacy Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body><PrivacyPolicy /></Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleClosePP}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </footer>
    )
}

export default Footer